module.exports = __webpack_public_path__ + "static/media/PATS_6-480w.2be6a0bc.png";